module.exports = __webpack_public_path__ + "3168324f436267d819f7ee32fda0eff6.png";